import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Property } from '@/types/property';

interface FeatureListProps {
  features: string[];
  columns?: number;
}

export function FeatureList({ features, columns = 3 }: FeatureListProps) {
  if (!features || features.length === 0) return null;
  
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-${columns} gap-x-3 gap-y-1`}>
      {features.map((feature, index) => (
        <div key={index} className="flex items-center gap-2 py-1">
          <div className="h-2 w-2 rounded-full bg-primary" />
          <span className="text-sm">{feature}</span>
        </div>
      ))}
    </div>
  );
}

interface PropertyFeaturesProps {
  property: Property;
}

export default function PropertyFeatures({ property }: PropertyFeaturesProps) {
  // Get all available feature types
  const propertyFeatures = property.property_features || [];
  const interiorFeatures = property.interior_features || [];
  const exteriorFeatures = property.exterior_features || [];
  
  // Don't render the card if there are no features
  if (propertyFeatures.length === 0 && interiorFeatures.length === 0 && exteriorFeatures.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Features</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {propertyFeatures.length > 0 && (
          <div>
            <h3 className="text-lg font-medium mb-2">Property Features</h3>
            <FeatureList features={propertyFeatures} />
          </div>
        )}
        
        {interiorFeatures.length > 0 && (
          <div>
            <h3 className="text-lg font-medium mb-2">Interior Features</h3>
            <FeatureList features={interiorFeatures} />
          </div>
        )}
        
        {exteriorFeatures.length > 0 && (
          <div>
            <h3 className="text-lg font-medium mb-2">Exterior Features</h3>
            <FeatureList features={exteriorFeatures} />
          </div>
        )}
      </CardContent>
    </Card>
  );
}